export const loadingStyles = "flex-grow flex justify-center items-center text-center p-4";